import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPedroBrocoli = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.5249 22.3502C21.6739 21.4901 22.3641 20.3874 22.3641 19.1852C22.3641 16.4367 18.7567 14.2086 14.3067 14.2086C11.311 14.2086 8.6972 15.2184 7.30871 16.7169C7.11207 16.5501 6.87927 16.424 6.61786 16.353C5.59918 16.0765 4.53188 16.7421 4.234 17.8396C3.93611 18.9371 4.52043 20.051 5.53911 20.3275C5.85069 20.412 6.16682 20.4085 6.46409 20.3314C6.78073 21.1611 7.4336 21.9106 8.32898 22.5221C8.30372 22.6332 8.29038 22.7487 8.29038 22.8674C8.29038 23.7231 8.98411 24.4169 9.83987 24.4169C10.3655 24.4169 10.8301 24.1551 11.1102 23.7548C12.0902 24.0167 13.171 24.1618 14.3067 24.1618C15.5378 24.1618 16.7045 23.9913 17.7481 23.6864C18.0216 24.1253 18.5087 24.4174 19.064 24.4174C19.9198 24.4174 20.6135 23.7237 20.6135 22.8679C20.6135 22.6864 20.5823 22.5121 20.5249 22.3502Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2494 27.1502C12.0511 24.0147 9.64586 20.296 5.89062 19.348L10.7579 18.0817C10.7579 18.0817 10.7579 21.171 11.6875 21.171C14.0027 21.171 12.0511 18.0817 12.0511 18.0817H15.7604C15.7604 18.0817 14.1625 21.5627 15.7604 21.7908C17.3584 22.0188 17.1912 17.8168 17.1912 17.8168H23.4971C18.8339 21.5261 16.6824 23.5408 18.8339 27.1502H10.2494Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 14.5495,
			cy: 27.1502,
			rx: 4.28389,
			ry: .656255,
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.67608 9.94197C3.67608 10.6205 3.98501 11.2269 4.46988 11.6281C2.04911 12.8714 0.612065 14.8884 1.09206 16.6797C1.69776 18.9403 5.12682 19.9855 8.75107 19.0144C9.60622 18.7853 10.3958 18.4644 11.0953 18.078C11.2979 18.567 11.7798 18.9109 12.342 18.9109C12.87 18.9109 13.3272 18.6075 13.5487 18.1655C14.9135 20.939 19.6237 21.5653 24.1791 19.5483C28.8065 17.4993 31.5217 13.4986 30.2437 10.6124C29.0669 7.95463 24.9144 7.16873 20.6511 8.66086C20.6517 8.64486 20.6519 8.6288 20.6519 8.61267C20.6519 7.79718 19.9908 7.1361 19.1753 7.1361C18.759 7.1361 18.383 7.30838 18.1146 7.58552C17.2454 5.48099 15.1728 4 12.7544 4C10.1083 4 7.87622 5.77298 7.18142 8.1958C6.81491 7.91877 6.35844 7.75446 5.8636 7.75446C4.65547 7.75446 3.67608 8.73384 3.67608 9.94197ZM13.1706 16.4974L13.1518 16.483L13.1708 16.4618L13.1706 16.4974Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.6907,
			cy: 15.6341,
			rx: 3.66289,
			ry: 1.6483,
			transform: "rotate(-25.9302 23.6907 15.6341)",
			fill: "#4EA4BD"
		})
	]
});
const ForwardRef = forwardRef(SvgPedroBrocoli);
export default ForwardRef;
